import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
const FooterContainer = lazy(() =>
  import("../FooterNavigation/FooterContainer")
);

const VendorFooterPremium = props => {
  return (
    <React.Fragment>
      <Suspense fallback={<></>}>
        <FooterContainer />
      </Suspense>

      <script>
        {props.tracking && props.tracking.lead
          ? window.heap.identify({ handle: props.tracking.lead })
          : null}
      </script>
      <script>
        {props.tracking && props.tracking.lead
          ? window.ga("set", "userId", `${props.tracking.lead}`)
          : window.ga("send", "pageview")}
      </script>
    </React.Fragment>
  );
};

const mapStatetoProps = state => {
  return {
    totalReviewCount: state.webSiteCommonData.total_reviews_count,
    tracking: state.webSiteCommonData.common_tracking,
  };
};

export default connect(mapStatetoProps)(VendorFooterPremium);
